import Google from './Systems/Google';
import Google4 from './Systems/Google4';
import GoogleTagManager from './Systems/GTM';
import Amazon from './Systems/Amazon';
import Amplitude from './Systems/Amplitude';

import { ITrackOptions } from './Interfaces/Events';

export const SYSTEMS = {
  ga: Google,
  ga4: Google4,
  gtm: GoogleTagManager,
  amazon: Amazon,
  amplitude: Amplitude,
};

export const TRACK_DEFAULT_OPTIONS: ITrackOptions = {
  isPrefix: true,
};
